import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { DeviceManagedState } from './interfaces/extension-store.interfaces';

export const GlobalAppFlagsState = createSlice({
  name: 'GlobalAppFlagsState',
  initialState: {
    isLoaded: false,
    deviceManagedState: DeviceManagedState.MANAGED,
  },
  reducers: {
    setLoaded: (mutableState) => {
      mutableState.isLoaded = true;
    },
    setdeviceManagedState: (mutableState, action: PayloadAction<DeviceManagedState>) => {
      mutableState.deviceManagedState = action.payload;
    },
  },
});

export const { setLoaded, setdeviceManagedState } = GlobalAppFlagsState.actions;
